"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const polished_1 = require("polished");
const render_icon_1 = __importDefault(require("../../icons/render-icon"));
const create_use_styles_1 = __importDefault(require("../../theming/create-use-styles"));
const is_element_1 = __importDefault(require("../utils/is-element"));
const menu_list_1 = __importStar(require("./menu-list"));
function alignmentStyle(alignment) {
    switch (alignment) {
        case "start":
            return {
                alignItems: "flex-start",
            };
        case "end":
            return {
                alignItems: "flex-end",
            };
        case "center":
        default:
            return {
                alignItems: "center",
            };
    }
}
const useStyles = (0, create_use_styles_1.default)(({ breakpoints, colors, spacing, typography }) => ({
    active: {
        "backgroundColor": colors.lightprimary,
        "ul &, ul:only-of-type:not(:only-child) &": {
            "& > $wrapper": {
                fontWeight: typography.fontWeights.semiBold,
            },
            "&:not(:hover) $leftIcon": {
                color: colors.primary,
            },
        },
    },
    leftIcon: {
        flexShrink: 0,
    },
    rightIcon: {
        flexShrink: 0,
        marginLeft: spacing(12),
    },
    text: {
        "display": "inline-flex",
        "flexGrow": 1,
        "$leftIcon + &": {
            marginLeft: spacing(12),
        },
    },
    wrapper: ({ alignItems, indentLevel }) => (0, lodash_merge_1.default)({
        "display": "flex",
        "alignItems": "center",
        "color": "inherit",
        "&:not(:empty)": {
            padding: spacing("sm", "md"),
            paddingLeft: (0, polished_1.math)(`${indentLevel} * ${spacing("xl")} - ${spacing("md")}`),
        },
        "&:focus": {
            outline: 0,
        },
        "ul:only-of-type:not(:only-child) &": typography.small,
        [breakpoints.down("xs")]: {
            padding: spacing("sm", "xl"),
        },
    }, alignmentStyle(alignItems)),
}));
function splitChildren(children, { collapsed, indentLevel }) {
    const nested = [];
    let labels = [];
    react_1.default.Children.forEach(children, (child, index) => {
        if (!child)
            return;
        if ((0, is_element_1.default)(child) && child.type === menu_list_1.default) {
            nested.push(react_1.default.cloneElement(child, { key: index, ...child.props, collapsed, indentLevel }));
        }
        else {
            labels.push(child);
        }
    });
    return { nested, label: labels[0] };
}
exports.MenuItem = react_1.default.forwardRef(function MenuItem({ active = false, alignItems, children, className, collapsed, indentLevel = 1, leftIcon, rightIcon, ...props }, ref) {
    const context = (0, react_1.useContext)(menu_list_1.MenuListContext);
    const classes = useStyles({ alignItems: alignItems || context.alignItems, indentLevel });
    const { label, nested } = (0, react_1.useMemo)(() => splitChildren(children, { collapsed, indentLevel }), [children, collapsed, indentLevel]);
    const trueLabel = (0, is_element_1.default)(label) ? label.props.children : label;
    const wrapped = (react_1.default.createElement(react_1.default.Fragment, null,
        (0, render_icon_1.default)(leftIcon, classes.leftIcon),
        !collapsed && react_1.default.createElement("span", { className: classes.text }, trueLabel),
        !collapsed && (0, render_icon_1.default)(rightIcon, classes.rightIcon)));
    return (react_1.default.createElement("li", { ref: ref, className: (0, classnames_1.default)({ [classes.active]: !!active }, className), ...props },
        (0, is_element_1.default)(label) ? (react_1.default.cloneElement(label, {
            ...label.props,
            children: wrapped,
            className: (0, classnames_1.default)(classes.wrapper, label.props.className),
        })) : (react_1.default.createElement("span", { className: classes.wrapper }, wrapped)),
        nested));
});
exports.default = exports.MenuItem;
//# sourceMappingURL=data:application/json;base64,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